import { Injectable } from '@angular/core';
import { Observable, of, Subject, Observer } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Site } from '../models/Site';

@Injectable({
  providedIn: 'root'
})
export class SiteService {


  /* store state here */
  sites: Site[] = [];
  _tempSites: Site[] = [];
  isSearchOn: boolean;



  constructor(private http: HttpClient) {
    //this.getAllSites()
  }

  search(searchInput: string) {

    if (this._tempSites.length === 0)
      this._tempSites = this.sites


    this.sites = this._tempSites;

    this.sites = this.sites.filter(x => x.site_name.toLowerCase().includes(searchInput.toLowerCase()));
  }

  siteSearchInit(){
    this.sites = this._tempSites;
  }



  addSite(siteName: string): Observable<any> {

    var newSite = new Site();
    newSite.site_name = siteName;

    return this.http.post('core-service/api/site', newSite); // TODO:pipe and catchError
  }

  addSNMPSite(site: any): Observable<any> {    
    return this.http.post('core-service/api/site/snmp', site); // TODO:pipe and catchError
  }

  updateExistingSite(newSite: Site): Observable<any> {
    return this.http.post('core-service/api/site', newSite);
  }


  //Get all sites in a region
  getSitesByRegionId(regionId: number): void {
    this.sites = [];

    this.http.get<[Site]>('core-service/api/site?site_region_id=' + regionId)
      .pipe(tap(res => console.log(res)), catchError(this.handleError<any>('getSites')))
      .subscribe((res: Site[]) => {
        this.sites = res
      })
  }

  //Get site by site_id
  getSiteById(siteId: number): Observable<[Site]> {
    return this.http.get<[Site]>('core-service/api/site?site_id=' + siteId).pipe(
      catchError(this.handleError<any>('site'))
    );
  }

  xgetSites() : Observable<Site[]> {
    return this.http.get<Site[]>("core-service/api/site")
  }
  //get every site that is enabled, used at the moment in site swop.. every site in every region
  getAllSites() {
    this.sites = []
    this.http.get<Site[]>('core-service/api/site').pipe(
      catchError(this.handleError<any>('site'))
    ).subscribe((sites: Site[]) => {
      this.sites = sites;
      this._tempSites = sites;
    })
  }

  getAllSitesObs(): Observable<[any]> {
    return this.http.get<[Site]>('core-service/api/site').pipe(
      catchError(this.handleError<any>('site'))
    );
  }

  getSitesByName(name: string): Observable<Site[]> {
    let url = `core-service/api/site?site_name=${name}*`;
    return this.http.get<Site[]>(url).pipe(
      catchError(this.handleError<any>('site'))
    )
  }

  filterSitesByName(name: string) {
    let url = `core-service/api/site?site_name=*${name}*`;
    return this.http.get<Site[]>(url).pipe(
      catchError(this.handleError<any>('site'))
    ) .subscribe((res: Site[]) => {
      this.sites = res
    })
  }


  deleteSite(siteId: number): Observable<any> {
    return this.http.delete<any>("core-service/api/site?site_id=" + siteId)
  }

  swopSites(siteId: number, swopWithId: number): Observable<Site> {
    return this.http.post<Site>("core-service/api/site/swop?site_id=" + siteId + "&swop_with_id=" + swopWithId, {}).pipe(
      catchError(this.handleError<any>('site'))
    )
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
